import { render, staticRenderFns } from "./EmployeeDepartmentCreateOrUpdate.vue?vue&type=template&id=01431536&"
import script from "./EmployeeDepartmentCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./EmployeeDepartmentCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports